import React from 'react';
import { useSelector } from 'react-redux';
import ItemCard from '../../components/ItemCard';
import { selectFavoritesItems } from '../../features/favorites/selectors';
import './styles.css';

const FavoritesPage = () => {
    const favorites = useSelector(selectFavoritesItems);

    return (
        <div className="favorites-page">
            {favorites.length > 0 ? <h1 className="favorites-header">Избранное</h1> : null}

            {favorites.length > 0 ? (
                <div className="favorites-grid">
                    {favorites.map((item) => (
                        <ItemCard
                            key={item.id}
                            item={item}
                            {...item}
                        />
                    ))}
                </div>
            ) : (
                <div className="favorites-empty">
                    <h2>Ваш список избранного пуст</h2>
                    <p>Добавляйте товары, нажимая на сердечко в карточке товара.</p>
                </div>
            )}
        </div>
    );
};

export default FavoritesPage;